import {
  put,
  take
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import Token from "../../Token/Token";
import Socket from "../../Socket/Socket";
import Store from "../../Store/Store";
import Logger from "../../Logger/Logger";
import Rollbar from "../../API/Rollbar/Rollbar";
// import Environment from "../../Environment/Environment";
// var md5 = require('md5');

export const firstTasksToFinish: string[] = [
  Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST,
  Constants.GLOBAL_CONTRACT_STATUSES_LIST
];

export const tasks: string[] = [
  Constants.GLOBAL_REMINDERS_SAVE_LIST,
  // Constants.GLOBAL_NOTIFICATIONS_COUNT,
  Constants.GLOBAL_ACTIVITIES_COUNT,
  Constants.GLOBAL_UNFINISHED_TASKS_COUNT,
  Constants.GLOBAL_BANK_ACCOUNT_LIST,
  Constants.GLOBAL_AGENCY_LIST,
  Constants.GLOBAL_PERSON_LIST,
  Constants.GLOBAL_COMPANY_LIST,
  Constants.GLOBAL_PROPERTY_LIST,
  Constants.GLOBAL_UNIT_LIST,
  Constants.GLOBAL_CONTRACT_LIST,
  Constants.GLOBAL_CHARGE_TEMPLATE_LIST,
  Constants.GLOBAL_AGENCY_FEE_LIST,
  Constants.GLOBAL_EMAIL_ACCOUNT_LIST,
  Constants.GLOBAL_TRANSACTION_FILE_LIST,
  Constants.GLOBAL_ACTIVITY_TEMPLATE_LIST,
  Constants.GLOBAL_TASK_TEMPLATE_LIST,
  Constants.GLOBAL_CONVERSATIONS_SAVE_LIST
];

export function* AuthSequence() {
  // First we should fetch all datatypes and do not start fetch anything else before types are not received
  yield firstTasksToFinish.map(task => put({ type: task}));
  yield firstTasksToFinish.map(task => take(task + "_SUCCESS"));

  // Fetch all the entities from backend. (Note: It doesn't delay the saga, just triggers the fetcher)
  yield tasks.map(task => put({ type: task}));

  // Watch the token
  Token.watch();

  // Connect the socket
  Socket.connect();

  const user = Store.getConfigurator().getState().app?.session?.user;

  // need update user info for rollbar
  Rollbar.configure(user);
  Logger.log(`${user?.displayName} is logged in!`, true);

  // if (Environment.isProduction()) {
  //   const helpCrunchUser = {
  //     email: user?.email,
  //     name: user?.firstName,
  //     user_id: `${user?.id}`,
  //     phone: user?.phone1,
  //     company: user?.companies?.[0]?.name
  //   };
  
  //   (window as any).HelpCrunch('logout', function() {
  //     (window as any).HelpCrunch('userAuth', {
  //       ...helpCrunchUser
  //     }, md5(`${JSON.stringify(helpCrunchUser)}${Environment.get().helpCrunchOrganizationSecret}`));
    
  //     (window as any).HelpCrunch('showChatWidget');
  //   });
  // }

  // Clear all the previous errors on Auth screen
  yield put({
    type: Constants.ALERT_HIDE
  });
}
